import BaseInputControl from "./BaseInputControl";
import type { HandleInputChange } from "./types";

type TimeInputProps = {
    name: string;
    value?: string | number;
    placeholder?: string;
    disabled?: boolean;
    onChange: HandleInputChange;
};

const TimeInput = ({ name, value, placeholder, disabled = false, onChange }: TimeInputProps) => {
    return (
        <BaseInputControl
            type="time"
            name={name}
            value={value}
            placeholder={placeholder}
            onChange={onChange}
            disabled={disabled}
        />
    );
};

export default TimeInput;
